import { S2E_LAYOUT_TYPE } from '../../../../../../models/User';
import S2EPreviewOneRectangle from './previews/one-rectangle';
import S2EPreviewTwoSquares from './previews/two-squares';
import S2EPreviewTwoRectangles from './previews/two-rectangles';
import S2EPreviewThreeRectangles from './previews/three-rectangles';
import S2EPreviewFourSquares from './previews/four-squares';

interface IProps {
	type: S2E_LAYOUT_TYPE;
	images: (string|undefined)[]
}

export interface IPreviewProps {
	images: (string|undefined)[];
}

const S2ELayoutPreview: React.FC<IProps> = ({ type, images }) => {

	switch (type) {
		case S2E_LAYOUT_TYPE.ONE_RECTANGLE:
			return <S2EPreviewOneRectangle images={images}/>;
		case S2E_LAYOUT_TYPE.TWO_RECTANGLES:
			return <S2EPreviewTwoRectangles images={images}/>;
		case S2E_LAYOUT_TYPE.THREE_RECTANGLES:
			return <S2EPreviewThreeRectangles images={images}/>;
		case S2E_LAYOUT_TYPE.TWO_SQUARES:
			return <S2EPreviewTwoSquares images={images}/>;
		case S2E_LAYOUT_TYPE.FOUR_SQUARES:
			return <S2EPreviewFourSquares images={images}/>;
	}

	return null;
}

export default S2ELayoutPreview;
